/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import { useSingleTransactionLog } from './Hooks';
import { useTranslation } from 'react-i18next';
import ChargingAnalyticsCharts from '../../components/ChargingAnalyticsCharts';
import PropTypes from 'prop-types';
import { formatKwFromWatts } from '../../utils/utils';
import { formatKwh } from '../../utils/utils';

const formatDate = (unixTimestamp) => {
  return new Date(unixTimestamp * 1000).toLocaleString();
};

const TransactionLogsAccordion = ({ transactionId, operatorId }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { data: logsData, isLoading: isLoadingLogs } = useSingleTransactionLog({
    transactionId,
  });

  const handleCollapseChange = (key) => {
    setIsOpen(!!key);
  };

  const columns = [
    {
      title: t('timestamp'),
      dataIndex: 'created_at',
      key: 'timestamp',
      align: 'center',
      render: (value) => formatDate(value),
    },
    {
      title: t('context'),
      dataIndex: 'context',
      key: 'context',
      align: 'center',
    },
    {
      title: t('measurand'),
      dataIndex: 'measurand',
      key: 'measurand',
      align: 'center',
    },
    {
      title: `${t('value')} (kWh)`,
      dataIndex: 'value',
      key: 'value',
      align: 'center',
      render: (value) => formatKwh(value),
    },
    {
      title: `${t('chargerPower')} (kW)`,
      dataIndex: 'chargerSupplyPower',
      key: 'chargerSupplyPower',
      align: 'center',
      render: (value) => formatKwFromWatts(value),
    },
    {
      title: `${t('chargerVoltage')} (V)`,
      dataIndex: 'chargerSupplyVoltage',
      key: 'chargerSupplyVoltage',
      align: 'center',
      render: (value) => value.toFixed(0),
    },
    {
      title: `${t('chargerCurrent')} (A)`,
      dataIndex: 'chargerSupplyCurrent',
      key: 'chargerSupplyCurrent',
      align: 'center',
      render: (value) => value.toFixed(0),
    },
    {
      title: `${t('evDemandPower')} (kW)`,
      dataIndex: 'EVdemandPower',
      key: 'EVdemandPower',
      align: 'center',
      render: (value) => formatKwFromWatts(value),
    },
    {
      title: `${t('evDemandVoltage')} (V)`,
      dataIndex: 'EVdemandVoltage',
      key: 'EVdemandVoltage',
      align: 'center',
      render: (value) => value.toFixed(0),
    },
    {
      title: `${t('evDemandCurrent')} (A)`,
      dataIndex: 'EVdemandCurrent',
      key: 'EVdemandCurrent',
      align: 'center',
      render: (value) => value.toFixed(0),
    },
  ];

  TransactionLogsAccordion.propTypes = {
    transactionId: PropTypes.string.isRequired,
    operatorId: PropTypes.string.isRequired,
  };

  return (
    <>

      {!isLoadingLogs && logsData?.paginatedData && Array.isArray(logsData.paginatedData) && logsData.paginatedData.length > 0 && (
        <ChargingAnalyticsCharts
          data={logsData.paginatedData}
          transactionId={transactionId}
        />
      )}

    </>
    // <Collapse
    //   onChange={handleCollapseChange}
    //   expandIcon={({ isActive }) => (
    //     <ExpandOutlined rotate={isActive ? 90 : 0} className="text-gray-500" />
    //   )}
    //   accordion
    // >
    //   <Collapse.Panel
    //     header={
    //       <div className="flex justify-between items-center">
    //         <div>{t('transactionLogs')}</div>
    //       </div>
    //     }
    //     key="1"
    //   >
    //     {!isLoadingLogs && logsData?.data?.paginatedData?.length > 0 && (
    //       <div className="flex justify-end mb-4">
    //         <Button
    //           type="default"
    //           onClick={handleExportCSV}
    //           className="text-right"
    //         >
    //           {t('exportCSV')}
    //         </Button>
    //       </div>
    //     )}
    //     {isLoadingLogs ? (
    //       <div className="flex justify-center items-center">
    //         <Spin size="small" />
    //       </div>
    //     ) : logsData?.data?.paginatedData?.length ? (
    //       <Table
    //         columns={columns}
    //         dataSource={logsData.data.paginatedData}
    //         pagination={false}
    //         size='middle'
    //         rowKey={(record, index) => index}
    //         scroll={{ x: 'max-content', y: 60 * 8 }}

    //         />
    //     ) : (
    //       <Empty description={t('noTransactionLogsAvailable')} />
    //     )}
    //   </Collapse.Panel>
    // </Collapse>
  );
};

export default TransactionLogsAccordion;
